/**
 * info-model.js
 *
 * 概述:
 * 基本信息管理服务API
 * 备注：对机构以及其所属的科目，学校，教师，班级，学年等基本信息进行增删改查
 *
 * API:
 * 1.查询机构所属科目信息    querySubjectInfo
 * 2.查询机构所属教研员信息  queryChargeInfo
 * 3.查询学年        currentXueNian
 * 4.搜索学校        searchSchool
 * 5.查询教师信息    queryAllTeacher
 * 6.查询组织机构关系树（不包含学校） getOrganizationsById
 * 7.批量匹配学校           matchSchools
 * 8.查询学校科目信息       querySchoolSubjects
 * 9.查询学校班级信息       querySchoolClasses
 * 10.增加老师       addTeacher
 * 11.查询用户信息   getUserInfo
 * 12.修改老师       updateTeacher
 * 13.查询所有班级       queryClasses
 * 14.导入学生(三个接口依次调用)   importStudentOneStep -> importStudentSecondStep -> importStudentThirdStep
 * 15.导出学生   exportStudent
 * 16.增加班级   addClass
 * 17.查询班级信息  queryClassInfo
 * 18.查询学校的教师信息  queryTeachers
 * 19.查询班级学生信息    queryStudentsOfClass
 * 20.修改班级信息    updateClassInfo
 * 21.增加学生    addStudent
 * 22.修改学生    updateStudent
 * 23.删除学生    deleteStudent
 * 24.删除班级    deleteClass
 * 25.学校导入老师    importTeacherAsync
 * 26.机构导入老师（下跌带才有）    importTeacherFromOrgAsync
 * 27.修改机构下所属用户信息    editUserFromOrg
 * 28.删除机构用户             deleteUserFromOrg
 * 29.机构导入老师（旧接口，下迭代换掉）    importTeacherFromOrgOneStep -> importTeacherFromOrgSecondStep
 * 30.机构批量导入账号（下迭代才有）        importAccountFromOrgAsync
 * 31.学校导入学生(下迭代才有)             importStudentAsync
 * 32.教育局查询用户列表                   queryUserList
 * 33.加机构科目                          addOrganizationSubject
 * 34.导入用户头像                        importUserPhoto
 * 35.增量同步老师                        syncTeacher
 * 36.增量同步学校                        syncSchool
 * @author Qiutm 2018/4/28
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'

setConfig(axios)

const infoServer = '/InfoServer'
const baseInfoPath = '/BaseInfoWeb/action/baseinfo'
const baseInfoActionPath = '/BaseInfoWeb/action'
const authServicePath = '/AuthService'
const apiServicePath = '/api'
const basePathNew = '/ExamService'

const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

// 查询科目信息，level可选，不传代表查全部学阶的科目
const querySubjectInfo = (data = {'orgId': '', 'level': '', 'origanizationId': ''}) => {
  let param = 'app=getMerchSubjectList&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/user/userSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

// 查询教研员信息，role可选，不传代表查全部角色用户
const queryChargeInfo = (data = {'orgId': '', 'role': 3, 'origanization': ''}) => {
  let param = 'app=getUserList&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/user/user.jsp`, param, axiosConfig)
    .then(res => res.data)
}
/**
  *接口：获取租户信息；
  *参数：orgId
  * @returns promise
  * 返回：{'result':false, 'data':{organizationId:"111111"，name:"南山教育局",expireDate:"1",stuCnt:"500,1000",grade:[7,12],type:"00",province:"01",city:"01",region:"01",phone:"13723850000",nationalId:"123456789"}, 'desc':(!e.message?'':e.message)};
  */
const queryOrganization = (data = {'origanization': ''}) => {
  let param = 'app=getOrganization&flag=detail&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/user/organization.jsp`, param, axiosConfig)
    .then(res => res.data)
}

// 查询学年
const currentXueNian = () => {
  let param = 'app=getCurrentXueNian'
  return axios.post(`${baseInfoPath}/currentXueNian`, param, axiosConfig)
    .then(res => res.data)
}

// 搜索学校
const searchSchool = (param) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/getAllSchoolByOrgId`, data: param })
    .then(res => res.data)
}

/**
 * 查询教师信息
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return promise
 */
const queryAllTeacher = (data) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/teacher/queryAllTeacher`, data: data })
    .then(res => res.data)
}
/**
 * 分配评卷任务心跳接口
 * @author  chenxb 2020-11-12T11:12:02+0800
 * @param  {Object} params [description]
 * @return promise
 */
const listExamAllotPjTaskHeartBeat = (data) => {
  return axios({ method: 'POST', url: `${basePathNew}/listExamAllotPjTaskHeartBeat`, data: { data } })
    .then(res => res.data)
}
/**
 * 查询组织机构关系树
 * @param  data   {data: {organizationId: ''},pageNum: 1,pageSize: 10,token: "",userInfo: ""}
 * @return promise
 */
const getOrganizationsById = (data) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/getOrganizationsById`, data: data })
    .then(res => res.data)
}

/**
 * 批量匹配学校
 * @param  params {orgId: '', gradecode: '', file: '流文件'}
 * @return promise
 */
const matchSchools = (params) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/import/matchSchools/${params.orgId}/${params.gradeCode}`, data: params.file })
    .then(res => res.data)
}

/**
 * 查询用户信息
 * @author wangk 2018-05-19T10:06:18+0800
 * @param  {Object} params { userId: '123' }
 * @return promise
 */
const getUserInfo = (params = {}) => {
  let formData = 'app=getUserInfo&flag=detail&json=' + JSON.stringify(params)
  return axios.post(`${infoServer}/user/user.jsp`, formData, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询学校科目信息
 * @param  data {"orgid":""}
 * @return promise
 */
const querySchoolSubjects = (data) => {
  let param = 'app=schoolSubject&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/schoolSubject`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 取临时授权码
 * @param
 * @return promise
 */
const getTempAuthorizeCode = (params = {}) => {
  return axios.post(authServicePath + '/users/getTempAuthorizeCode', params)
    .then(res => res.data)
}
/**
 * 用户登出
 * @param
 * @return promise
 */
const logout = () => {
  let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
  let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
  let params = {
    access_token: localStorage.getItem(`kw_token-${userInfo.userId}`)
  }
  return axios.post(authServicePath + '/user/logout', params)
    .then(res => res.data)
}

/**
 * 查询学校班级信息
 * @param  data {"orgid":""}
 * @return promise
 */
const querySchoolClasses = (data) => {
  let param = 'app=classInfo&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 学生转班
 * @author wangk 2018-06-10T09:54:02+0800
 * @param  {[type]} data {
 *                         orgid: '', studentid: ['', ''],
 *                         classto: { gradeid: '10', classcode: '' }
 *                       }
 * @return {[type]}      [description]
 */
const changeClass = (data = {}) => {
  let param = 'app=studentInfo&flag=changeClass&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/studentInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询教师列表
 * @param  data {"orgid":""}
 * @return promise
 */
const queryTeacherList = (data) => {
  return axios.post(`${baseInfoPath}/teacher/pageList`, data)
    .then(res => res.data)
}

/**
 * 增加老师
 * @param data [{orgid: '',teacherid: '',teachername: '',password: '',tele: '',createdate: '',updatedate: '',roleinfo: [{ role: '2', names: [{ gradeid: ''}]}, { role: '4', names: [{subjectname: '', subjectid: '', gradeid: '', classid: '', classcode: '', classname: ''}]}],teacherrole: ['2', '4']}]
 * @return promise
 */
const addTeacher = (data) => {
  let param = 'app=addTeacher&flag=add&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/teacher/add`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改老师
 * @param data [{orgid: '',teacherid: '',teachername: '',password: '',tele: '',createdate: '',updatedate: '',roleinfo: [{ role: '2', names: [{ gradeid: ''}]}, { role: '4', names: [{subjectname: '', subjectid: '', gradeid: '', classid: '', classcode: '', classname: ''}]}],teacherrole: ['2', '4']}]
 * @return promise
 */
const updateTeacher = (data) => {
  let param = 'app=updateTeacher&flag=update&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/teacher/update`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除老师
 * @param data [{orgid: '',teacherid: ''}]
 * @return promise
 */
const delTeacher = (data) => {
  let param = 'app=deleteTeacher&flag=delete&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/teacher/delete`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 获取组织机构下某科目下老师数量
 * @param data {"data": {"examId": "string","orgId": "string","roleTypes": ["string"],"subjectName": ["string"]},"pageNum": 0,"pageSize": 0,"token": "string","userInfo": "string"}
 * @return promise
 */
const queryTeacherSize = (param) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/teacher/queryTeacherSize`, data: param })
    .then(res => res.data)
}

/**
 * 批量给教师添加科目
 * @param  params {orgId: '', gradecode: '', file: '流文件'}
 * @return promise
 */
const addPositionBatch = (data) => {
  let param = 'app=addPositionBatch&flag=addPositionBatch&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/teacher/addPositionBatch`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询所有班级
 * @param {object} param {"orgid":""}
 * @return promise
 */
const queryclasses = (data) => {
  let param = `app=classInfo&flag=query&json={"orgid":${data.orgid}}`
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导入学生-第一步：导入初始化
 * @param {object} params {"userid":"", file: '流文件'}
 * @return promise
 */
const importStudentOneStep = (params) => {
  let options = {flag: 'upload', json: {userid: params.userid}}
  return axios({ method: 'POST', url: `${baseInfoPath}/studentInfo/upload`, data: params.file, params: options })
    .then(res => res.data)
}

/**
 * 导入学生-第二步：校验格式与重导
 * @param {object} data {"userid":"1523870635108","file":"http://reportoss.kaow.cn/export/tmp/2018/6/5/successExport/25946/87219_0605102413.xls","schoolid":"1523870618981"}
 * @return promise
 */
const importStudentSecondStep = (data) => {
  let param = `app=importStudent&flag=import&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo/upload`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导入学生-第三步：查询导入学生数量
 * @param {object} data {"schoolid":"1523870618981","data":"82759"}
 * @return promise
 */
const importStudentThirdStep = (data) => {
  let param = `app=importStudent&flag=queryImportedStudentCnt&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo/upload`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导出学生
 * @param {object} data {"schoolid":"1523870618981","grades":["10","8","2"]}
 * @return promise
 */
const exportStudent = (data) => {
  let param = `json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo/export`, param, axiosConfig).then(res => res.data)
}

/**
 * 增加班级
 * @param {object} data {"orgid":"1523870618981","level":"high","classtype":0,"classnote":"","classcode":"16","grade":10,"desc":""}
 * @return promise
 */
const addClass = (data) => {
  let param = `app=classInfo&flag=add&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询班级信息
 * @param {object} data {"orgid":"1523870618981","classcode":"11-2"}
 * @return promise
 */
const queryClassInfo = (data) => {
  let param = `app=classInfo&flag=querySingle&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除班级学生信息
 * @param {object} data {
    'data': {
      schoolId: '',
      grade: '',
      classIdList: [''] //选填
    }
  }
 * @return promise
 */
const deleteStudentForSchool = (data) => {
  return axios.post(`${baseInfoPath}/deleteStudentForSchool`, data)
    .then(res => res.data)
}

/**
 * 查询所有年级信息
 *
 * @return promise
 */
const queryAllGrade = () => {
  return axios.post(`${baseInfoPath}/queryAllGrade`, null, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询老师信息
 * @param {object} data {"orgid":"1523870618981","subjectid":"","gradeid":"","classid":"","teacher":""}
 * @return promise
 */
const queryTeachers = (data) => {
  let param = `app=queryTeacher&flag=query&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/teacher/query`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询班级学生信息,新高考
 * @param  {Object} params {"orgid":"1571124979570","classcode":"1","grade":10,"adminClassType":"0"}
 * @return {Promise}
 * {
    "result":"true",
    "data":[
        {
            "orgid":" ",
            "gradeid":12,
            "classcode":"4",
            "studentid":"1f4b1a4331914322a53cb1c7f0c471ba",
            "studentname":"菊花",
            "studentshortcode":"9999999012",
            "studentcode":"",
            "studentidcard":"",
            "parenttele":"",
            "studentaccount":"1648865732280",
            "subject":"语文（学）",
            "schoolYearCode":"2021",
            "adminClass":{
                "classCode":"",
                "classMaster":"",
                "classMastername":"",
                "className":"",
                "classId":""
            },
            "teachingClass":[{
                "classCode":"",
                "className":"",
                "classId":""
            }]
        }
    ]
}
 */
const queryStudentsOfClass = (params) => {
  let paramString = `flag=query&json=${JSON.stringify(params)}`
  return axios.post(`${baseInfoPath}/studentInfo`, paramString, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改班级信息
 * @param {object} data {"orgid":"1523870618981","classinfo":{"gradeid":10,"classid":"b908373622ed4add81c1a2ac998ed70d","classcode":"2","classname":"(2)班","classtype":0,"classnote":"测试班级","classmaster":"1527582150654","classmastername":"bafy"}}
 * @return promise
 */
const updateClassInfo = (data) => {
  let param = `app=classInfo&flag=updateSingle&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 增加学生
 * @param {object} data {"studentname":"小青","studentshortcode":"12365","studentcode":"13655","parenttele":"13611114123","studentaccount":"","subject":"物理","studentid":"","orgid":"1526981240868","classcode":"1","grade":"11"}
 * @return promise
 */
const addStudent = (data) => {
  let param = `app=studentInfo&flag=add&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改学生
 * @param {object} data {"studentname":"小青","studentshortcode":"12365","studentcode":"13655","parenttele":"13611114123","studentaccount":"","subject":"物理","studentid":"","orgid":"1526981240868","classcode":"1","grade":"11"}
 * @return promise
 */
const updateStudent = (data) => {
  let param = `app=studentInfo&flag=update&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除学生
 * @param {object} data {"studentid":["f80d18c18a9d4b58879fb4751878c7eb"...]}
 * @return promise
 */
const deleteStudent = (data) => {
  let param = `app=studentInfo&flag=delete&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/studentInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除班级
 * @param {object} data {"orgid":"1526981240869","gradeid":"10","classcode":"1"}
 * @return promise
 */
const deleteClass = (data) => {
  let param = `app=classInfo&flag=delete&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/classInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导出老师
 * @param  {Object} params schoolid
 * @return {Promise}
 */
const exportTeacherAsync = (schoolid) => {
  let param = `app=studentInfo&flag=delete&json={"schoolid":"${schoolid}"}`
  return axios.post(`${baseInfoActionPath}/sync/account/export`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导入老师
 * @param  {Object} params { data:{orgId: '', userId: '', importType: '1'}, file: [file] }
 * @return {Promise}
 */
const importTeacherAsync = (params) => {
  return axios.post(`${baseInfoActionPath}/sync/account/upload?json=${encodeURIComponent(JSON.stringify(params.data))}`, params.file, axiosConfig)
    .then(res => res.data)
}

/**
 * 机构导入老师
 * @param  {Object} params { data:{orgId: '', userId: '', importType: '5'}, file: [file] }
 * @return {Promise}
 */
const importTeacherFromOrgAsync = (params) => {
  return axios.post(`${baseInfoActionPath}/sync/account/upload?json=${encodeURIComponent(JSON.stringify(params.data))}`, params.file, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改机构下所属用户信息
 * @param {object} data
 * @return promise
 */
const editUserFromOrg = (data) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/user/updateUser`, data: data })
    .then(res => res.data)
}

/**
 * 增加机构用户
 * @param {object} data
 * {data:{origanization:"",operateUserId:"",user:[{email:"",name:"",sex:"",role:"",pwd:"123456",mobilePhone:"",subjectName:"",qq:"",userGrade:"",status:"1"}]}}
 * @return promise
 */
const addUserFromOrg = (data) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/user/addUser`, data: data })
    .then(res => res.data)
}

/**
 * 删除机构用户
 * @param {object} data {data:{"operateUserId":"1523870605302","userId":[1527324018720]}}
 * @return promise
 */
const deleteUserFromOrg = (data) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/user/deleteUser`, data: data })
    .then(res => res.data)
}

/**
 * 导入老师-第一步：获取导入的老师信息
 * @param {object} params {"userId":"", file: '流文件'}
 * @return promise
 */
const importTeacherFromOrgOneStep = (params) => {
  let options = {flag: 'user', json: {userid: params.userId}}
  return axios({ method: 'POST', url: `${baseInfoPath}/teacher/importUser`, data: params.file, params: options })
    .then(res => res.data)
}

/**
 * 导入老师-第二步：获取导入成功或失败信息
 * @param {object} params
 * {
    "file":"/program/kaowFile/upload/uploadFile/2018/8/3/15/teacherOrStudent/1534315178574/89826_0815143938.xls",
    "pwd":"123456",
    "orgId":"1523870605221",
    "origanization":"1523870605221",
    "status":"1",
    "operateUserId":"1523870605302",
    "organizationid":"1523870605221"
    }
 * @return promise
 */
const importTeacherFromOrgSecondStep = (data) => {
  let param = `app=importBaseInfoUser&flag=import&json=${JSON.stringify(data)}`
  return axios.post(`${baseInfoPath}/teacher/importUser`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 机构导入账号
 * @param  {Object} params { data:{orgId: '', userId: '', importType: '6'}, file: [file] }
 * @return {Promise}
 */
const importAccountFromOrgAsync = (params) => {
  return axios.post(`${baseInfoActionPath}/sync/account/upload?json=${encodeURIComponent(JSON.stringify(params.data))}`, params.file, axiosConfig)
    .then(res => res.data)
}

/**
 * 学校导入学生
 * @param  {Object} params { data:{orgId: '', userId: '', importType: '2'}, file: [file] }
 * @return {Promise}
 */
const importStudentAsync = (params) => {
  return axios.post(`${baseInfoActionPath}/sync/account/upload?json=${encodeURIComponent(JSON.stringify(params.data))}`, params.file, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询用户列表
 * @param  {Object} param {data:{orgId: "",search: {condition: "", filterSubject: { studyStep: "",subjectName: ""}}}, pageNum: 1,pageSize: 10}
 * @return {Promise}
 */
const queryUserList = (param) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/user/queryUserList`, data: param })
    .then(res => res.data)
}

/**
 * 加机构科目
 * @param  {Object} param {data: {origanizationId: '123',type: '公共科目',subjectName:"1111",level:'primary'}}
 * @return {Promise}
 */
const addOrganizationSubject = (param) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/addMerchSubject`, data: param })
    .then(res => res.data)
}

/**
 * [description]
 * @author wangk 2018-11-30T14:31:36+0800
 * @param  {Object} params {
 *                           data: {
 *                              beginDate: '2018-08-12',
 *                              endDate: '2018-08-22',
 *                              // ALL: 全部; LOGIN: 登入; LOGOUT: 登出; DEL_EXAM: 删除考试; RESET_PASSWORD: 修改密码
 *                              // CREATE_EXAM: 创建考试; REMARK: 重评; CALC_SCORE: 出成绩
 *                              behavior: 'ALL',
 *                              searchKeyword: '' // 账号/机构/学校/考试名称
 *                            },
 *                            pageNum: 1,
 *                            pageSize: 10
 *                         }
 * @return {[type]}        [description]
 */
const getUserLogList = (params = {}) => {
  return axios.post(baseInfoPath + '/getUserLogList', params)
    .then(res => res.data)
}

/**
 * [description]
 * @author wangk 2018-11-30T15:23:02+0800
 * @param  {Object} params {
 *                           data: { id: 'xxx' }
 *                         }
 * @return {[type]}        [description]
 */
const getUserLogDetail = (params = {}) => {
  return axios.post(baseInfoPath + '/getUserLogId', params)
    .then(res => res.data)
}

/**
 * 查询运维人员列表
 * @author wangk 2018-12-03T10:47:51+0800
 * @param  {Object} params {
 *                           data: { devOpsName: '', orgId: '', roleId: '' },
 *                           pageSize: 10, pageNum: 1
 *                         }
 * @return {[type]}        [description]
 */
const queryDevOpsList = (params = {}) => {
  return axios.post(baseInfoPath + '/queryDevOpsList', params)
    .then(res => res.data)
}

/**
 * 添加运维人员
 * @author wangk 2018-12-03T10:56:36+0800
 * @param  {Object} params {
 *                           data: {
 *                             "devOpsName": "运维主管",
 *                             "devOpsPhone": "13789456123",
 *                             "orgId": "1",
 *                             "roleId": "9",
 *                             "roleName": "运维主管"
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const addDevOps = (params = {}) => {
  return axios.post(baseInfoPath + '/addDevOps', params)
    .then(res => res.data)
}

/**
 * 删除运维人员(支持批量删除)
 * @author wangk 2018-12-03T10:57:43+0800
 * @param  {Object} params {
 *                           data: {
 *                             "devOpsId": [ "1543558845298" ]
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const deleteDevOps = (params = {}) => {
  return axios.post(baseInfoPath + '/deleteDevOps', params)
    .then(res => res.data)
}

/**
 * 更新运维人员
 * @author wangk 2018-12-03T10:58:58+0800
 * @param  {Object} params {
 *                           data: {
 *                             "devOpsId": "1543558845298",
 *                             "devOpsName": "maiyikaiDevOps",
 *                             "devOpsPhone": "13789456123",
 *                             "roleId": "9",
 *                             "roleName": "运维主管"
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const updateDevOps = (params = {}) => {
  return axios.post(baseInfoPath + '/updateDevOps', params)
    .then(res => res.data)
}

/**
 * 修改密码
 * @author wangk 2018-12-03T10:59:33+0800
 * @param  {Object} params {
 *                           data: {
 *                             "newPassword": "kw123456",
 *                             "oldPassword": "kw123456789",
 *                             "userId": "1543562545447",
 *                             "verifyPassword": "kw123456"
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const updatePassword = (params = {}) => {
  return axios.post(baseInfoPath + '/updatePassword', params)
    .then(res => res.data)
}

/**
 * 重置密码
 * @author wangk 2018-12-03T11:00:10+0800
 * @param  {Object} params {
 *                           data: { "userId": "1543562545447" }
 *                         }
 * @return {[type]}        [description]
 */
const resetPassword = (params = {}) => {
  return axios.post(baseInfoPath + '/resetPassword', params)
    .then(res => res.data)
}

/**
 * 导入用户头像
 * @author qiutm 2018-12-13 15:15:55
 * @param  {Object} params {
 *                           data: { "userId": "1543562545447"},
 *                           file: [二进制流文件]
 *                         }
 * @return promise
 */
const importUserPhoto = (params) => {
  return axios({ method: 'POST', url: `${baseInfoPath}/uploadUserIcon/${params.data.userId}`, data: params.file })
    .then(res => res.data)
}

/**
 * 云平台增量同步老师
 * @author zhengbl 2019-11-14T11:00:10+0800
 * @param  {Object} params {
 *                           data: {
 *                              "infoSource": "2",
 *                              "userMobile": "13352655875"
 *                              }
 *                         }
 * @return {[type]}        [description]
 */
const syncTeacher = (params = {}) => {
  return axios.post(apiServicePath + '/sunShine/syncTeacher', params)
    .then(res => res.data)
}

/**
 * 云平台增量同步学校数据
 * @author zhengbl 2019-11-14T11:00:10+0800
 * @param  {Object} params {
 *                           data: {
 *                              "infoSource": "2",
 *                              "userMobile": "13352655875"
 *                              }
 *                         }
 * @return {[type]}        [description]
 */
const syncSchool = (params = {}) => {
  return axios.post(apiServicePath + '/sunShine/syncSchool', params)
    .then(res => res.data)
}

/**
 * 验证手机号码是否存在
 * @param  data   {data: {mobilePhone: ''}}
 * @return promise
 */
const verifyMobilePhone = (data) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${baseInfoPath}/verifyMobilePhone`, data, axiosConfigs)
    .then(res => res.data)
}
/**
 * 重置密码 - 获取图像验证码
 * @return promise
 */
const getCaptchaImage = (data) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${baseInfoPath}/captchaImage`, data, axiosConfigs)
    .then(res => res.data)
}
/**
 * 重置密码 - 发送验证码
 * @param  data   {data: {
 *            uuid: ''
              newPassword: '',
              verifyPassword: '',
              mobilePhone: '',
              code: ''
 * }}
 * @return promise
 */
const sendVertificationCodeByValidCode = (data) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${baseInfoPath}/sendVertificationCodeByValidCode`, data, axiosConfigs)
    .then(res => res.data)
}
/**
 * 重置密码 - 更新密码
 * @param  data   {data: {
*             phone: '',
              newPassword: '',
              smsCode: '',
 * }}
 * @return promise
 */
const updatePasswordBySMS = (data) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${baseInfoPath}/updatePasswordBySMS`, data, axiosConfigs)
    .then(res => res.data)
}
/**
 * 重置密码
 * @param  data   {data: {
 *             userName: '',
              newPassword: '',
              verifyPassword: '',
              verifySmsCode: ''
 * }}
 * @return promise
 */
const forgetPassword = (data) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${baseInfoPath}/forgetPassword`, data, axiosConfigs)
    .then(res => res.data)
}
/**
 * 查询用户信息
 * @author chenxb 2020-08-31T16:06:18+0800
 * @param  {Object} params {"userId":"admin","email":"admin@seaskylight.com","mobilePhone":"15007550755","qq":"123456","role":"1","userName":"管理员"}
 * @return promise
 */
const updateUserAccount = (params) => {
  let param = 'app=updateUser&flag=update&json=' + JSON.stringify(params) + '&time=' + Math.random()
  return axios.post(`${baseInfoPath}/updateUserAccount`, param, axiosConfig)
    .then(res => res.data)
}
/**
 * 查询管理员
 * @author chenxb 2020-09-29T16:06:18+0800
 * @param  {Object} params {"orgId":"123"}
 * @return promise
 */
const queryListManager = (params) => {
  return axios.post(baseInfoPath + '/listManager', params)
    .then(res => res.data)
}
/**
 * 查询机构学校列表 分页与学校类型查询由前端完成
 * @author chenxb 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: getShoolMemberList
 *   flag: query
 *   json: {"orgId":"1571124943143","name":""}
 * @return promise
 */
const queryOrg = (data = {'name': '', 'orgId': ''}) => {
  data.schoolName = data.name
  data.organizationId = data.orgId
  let param = 'app=getShoolMemberList&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/user/orgContact.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询系统所有的课程科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: getCourseSubjectList
 *   flag: query
 *   json: {"level":""}
 * @return promise
 */
const getCourseSubjectList = (data = {level: ''}) => {
  let param = 'app=getCourseSubjectList&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/courseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 添加课程科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: addCourseSubject
 *   flag: add
 *   json: {
                    coursename: datas.courseName,
                    level: datas.levelType,
                    remark: datas.courseMemo
                }
 * @return promise
 */
const addCourseSubject = (data = {level: ''}) => {
  let param = 'app=addCourseSubject&flag=add&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/courseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改课程科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: updateCourseSubject
 *   flag: update
 *   json: {
                    id: datas.id,
                    courseid: datas.courseId,
                    coursename: datas.courseName,
                    level: datas.levelType,
                    remark: datas.courseMemo
                }
 * @return promise
 */
const updateCourseSubject = (data = {level: ''}) => {
  let param = 'app=updateCourseSubject&flag=update&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/courseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除课程科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: updateCourseSubject
 *   flag: update
 *   json: {
 *            id: datas.id,
              courseid: datas.courseId,
            }
 * @return promise
 */
const deleteCourseSubject = (data = {level: ''}) => {
  let param = 'app=deleteBaseSubject&flag=remove&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/courseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}
/**
 * 查询系统所有的考试科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: getCourseSubjectList
 *   flag: query
 *   json: {"level":""}
 * @return promise
 */
const getExamSubjectList = (data = {level: ''}) => {
  let param = 'app=getBaseSubjectList&flag=query&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/baseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 添加考试科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: addCourseSubject
 *   flag: add
 *   json: {
                    coursename: datas.courseName,
                    level: datas.levelType,
                    remark: datas.courseMemo
                }
 * @return promise
 */
const addExamSubject = (data = {level: ''}) => {
  let param = 'app=addBaseSubject&flag=add&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/baseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 修改考试科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: updateCourseSubject
 *   flag: update
 *   json: {
                    id: datas.id,
                    courseid: datas.courseId,
                    coursename: datas.courseName,
                    level: datas.levelType,
                    remark: datas.courseMemo
                }
 * @return promise
 */
const updateExamSubject = (data = {level: ''}) => {
  let param = 'app=updateBaseSubject&flag=update&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/baseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 删除考试科目信息
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 *   app: updateCourseSubject
 *   flag: update
 *   json: {
 *            id: datas.id,
              courseid: datas.courseId,
            }
 * @return promise
 */
const deleteExamSubject = (data = {level: ''}) => {
  let param = 'app=deleteBaseSubject&flag=remove&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${infoServer}/base/baseSubject.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 机构下的所有用户信息查询
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    'key': '', //按关键字查询
    'subjectId':'', // 按科目筛选
    'role': '7', // 按角色筛选
    'orgId': '' //机构或学校
  }，
  'pageSize': 20,
  'pageNum': 1
}
 * @return promise
 */
const listSubordinateUser = (params) => {
  return axios.post(baseInfoPath + '/listSubordinateUser', params).then(res => res.data)
}

/**
 * 机构下的所有用户信息导出
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    'orgId': '' //机构或学校
  }
}
 * @return promise
 */
const exportSubordinateUser = (params) => {
  return axios.post(baseInfoPath + '/exportSubordinateUser', params).then(res => res.data)
}

/**
 * 查询所有客户标签
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    "keyWords":"": '' //关键字
  }，
  "pageSize":5,
  "pageNum": 2
}
 * @return promise
 */
const listOrgTag = (params) => {
  return axios.post(baseInfoPath + '/listOrgTag', params).then(res => res.data)
}

/**
 * 新增客户标签
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    'orgId': '' //机构或学校
  }
}
 * @return promise
 */
const saveOrgTag = (params) => {
  return axios.post(baseInfoPath + '/saveOrgTag', params).then(res => res.data)
}

/**
 * 查询教学班列表
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    'orgId': '' //机构或学校
  }
}
 * @return promise
 */
const queryTeachingClass = (params) => {
  return axios.post(baseInfoPath + '/listTeachingClass', params).then(res => res.data)
}

/**
 * 增加班级
 * @param {object}
 * {
    "orgId":"1571124979570",
    "level":"high",
    "classNote":"",
    "classCode":6,
    "grade":"10",
    "subjectId":""
    "desc":""
}
 * @return promise
 */
const addTeachingClass = (params) => {
  return axios.post(baseInfoPath + '/addTeachingClass', params).then(res => res.data)
}
/**
 * 设置教学班老师
 * @param {object}
 * {"data":{"teacherId":"1571124979570","classId":""}}
 * @return promise
 */
const updateTeachClassTeacher = (params) => {
  return axios.post(baseInfoPath + '/updateTeachClassTeacher', params).then(res => res.data)
}

/**
 *  查询行政班列表
 * @author changh 2020-09-29T16:06:18+0800
 * @param  {Object} params
 {
  'data': {
    'orgId': '' //机构或学校
  }
}
 * @return promise
 */
const queryAdminClass = (params) => {
  return axios.post(baseInfoPath + '/listAdminClass', params).then(res => res.data)
}

/**
 *  批量删除班级,教学班，行政班
 * @author changh 2022-05-29T16:06:18+0800
 * @param  {Object} params
 {
    "data":{
        "schoolId":"1571124979570",
        "grade":12,
        "adminClassIdList":[
            "2b036ea488794e289f4e88de03291577",
            "d842c6574daf40fe81ff77825aa75c61"
        ],
        "teachingClassIdList":[
            "2b036ea488794e289f4e88de03291577",
            "d842c6574daf40fe81ff77825aa75c61"
        ]
    }
}
 * @return promise
 */
const deleteClasssForSchool = (params) => {
  return axios.post(baseInfoPath + '/deleteClasssForSchool', params).then(res => res.data)
}

/**
 *  检验新高考班级,教学班，行政班
 * @author changh 2022-05-29T16:06:18+0800
 * @param  {Object} params
 {
    "data":{
        "examXgkType":"1：3+1+2； 2：3+3",
        "schoolId":1111,
        "subjectList":[{
            subjectId:"2b036ea488794e289f4e88de03291577",
            subjectName:"d842c6574daf40fe81ff77825aa75c61",
            subjectXgkType:"111"
          }
        ],
        "classList":[{
            classId:"2b036ea488794e289f4e88de03291577",
            className:"d842c6574daf40fe81ff77825aa75c61"
          }
        ]
    }
}
 * @return promise
 */
const checkClassForXgk = (params) => {
  return axios.post(baseInfoPath + '/checkClassForXgk', params).then(res => res.data)
}

export {
  querySubjectInfo,
  queryChargeInfo,
  queryOrganization,
  currentXueNian,
  searchSchool,
  queryAllTeacher,
  listExamAllotPjTaskHeartBeat,
  getOrganizationsById,
  matchSchools,
  getUserInfo,
  querySchoolSubjects,
  querySchoolClasses,
  changeClass,
  queryTeacherList,
  addTeacher,
  updateTeacher,
  delTeacher,
  queryTeacherSize,
  addPositionBatch,
  queryclasses,
  importStudentOneStep,
  importStudentSecondStep,
  importStudentThirdStep,
  exportStudent,
  addClass,
  queryClassInfo,
  deleteStudentForSchool,
  queryTeachers,
  queryStudentsOfClass,
  updateClassInfo,
  addStudent,
  updateStudent,
  deleteStudent,
  deleteClass,
  exportTeacherAsync,
  importTeacherAsync,
  importTeacherFromOrgAsync,
  editUserFromOrg,
  addUserFromOrg,
  deleteUserFromOrg,
  importTeacherFromOrgOneStep,
  importTeacherFromOrgSecondStep,
  importAccountFromOrgAsync,
  importStudentAsync,
  queryUserList,
  addOrganizationSubject,
  getUserLogList,
  getUserLogDetail,
  queryDevOpsList,
  addDevOps,
  deleteDevOps,
  updateDevOps,
  updatePassword,
  resetPassword,
  importUserPhoto,
  getTempAuthorizeCode,
  logout,
  syncTeacher,
  syncSchool,
  queryAllGrade,
  verifyMobilePhone,
  getCaptchaImage,
  sendVertificationCodeByValidCode,
  updatePasswordBySMS,
  forgetPassword,
  updateUserAccount,
  queryListManager,
  queryOrg,
  getCourseSubjectList,
  addCourseSubject,
  updateCourseSubject,
  deleteCourseSubject,
  getExamSubjectList,
  addExamSubject,
  updateExamSubject,
  deleteExamSubject,
  listSubordinateUser,
  exportSubordinateUser,
  saveOrgTag,
  listOrgTag,
  queryTeachingClass,
  addTeachingClass,
  queryAdminClass,
  updateTeachClassTeacher,
  deleteClasssForSchool,
  checkClassForXgk
}



// WEBPACK FOOTER //
// ./src/model/info-model.js